import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=add838cc&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"
import style0 from "./audioPlayer.vue?vue&type=style&index=0&id=add838cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add838cc",
  null
  
)

export default component.exports